if (!customElements.get('accordion-item')) {
  class AccordionItem extends HTMLElement {
    selectors = {
      summary: '[accordion-item="summary"]',
      content: '[accordion-item="content"]',
    };
    constructor() {
      super();
    }

    connectedCallback() {
      this.summary = this.querySelector(this.selectors.summary);
      this.content = this.querySelector(this.selectors.content);
      this.summary.addEventListener('click', () => {
        this.toggleAccordion();
      });
    }

    toggleAccordion() {
      this.classList.toggle('open');
      this.summary.setAttribute('aria-expanded', this.content.classList.contains('open'));
      this.content.setAttribute('aria-hidden', !this.content.classList.contains('open'));
    }
  }
  customElements.define('accordion-item', AccordionItem);
}